import * as React from 'react';
import { useState } from 'react';
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner } from "react-bootstrap";
import * as yup from 'yup';
import * as formik from 'formik';
import atlasApi from "../utils/atlasapi";
import schemas from "../data/dataSchemas";
import types from "../data/dialogTypes";


export interface diagProps {
	owner: object;
	onClose: (value: string) => void;
}

const { Formik } = formik;


class DialogPropertyAttribute extends React.Component {

	

	constructor(props) {
		super(props);
		
		this.state = {
			validated: false,
			status: {sent:null, message:''}
		}
		
		
		
		//this.owner = schemas.owner.cast(this.props.owner);
		
	}
	updateStatus(s){
		var x = {...this.state};
		x.status = s;
		this.setState(x);
		this.forceUpdate();
	}


	handleClose(data){
		this.props.onClose(data);
		this.updateStatus({sent:null, message:''});
	};
	handleOnShow(e){
		this.forceUpdate();
	};

	handleSubmit(data, { resetForm }){

		if(!data.attribute_id)
			delete data.atribute_id;
		
		
		if(this.props.attributes.map((i)=>{return i.key}).includes(data.key)){
			this.updateStatus({sent:null, error:true, success:false, message:'this key exists'});
			return;
		}
		
		this.updateStatus({sent:false, success:false, message:'Adding dialog...'});
		//saveguard for testing

		
		if(this.props.onSubmit){
			this.props.onSubmit(data);
		}
		this.handleClose(data);
		
	};


	render() {
		
		this.validation = schemas.propertyAttribute;
		
		this.validation = this.validation.shape({uniqueKey:yup.string().test(
				'is-unique',
				(d) => 'An attribute with this label already exists for this property',
				(value, obj) => {
					return !this.props.attributes.map((i)=>{return i.key}).includes(obj.parent.key);
				},
			  )
		  });
		
		var key = this.props.setup.item ? this.props.setup.item.key : '';
		var value = this.props.setup.item ? this.props.setup.item.value : '';
		var id = this.props.setup.item ? this.props.setup.item.attribute_id : '';
		
		return (
			
			<Modal show={this.props.setup.open} onHide={(e)=>this.handleClose(e)} onShow={(e)=>this.handleOnShow(e)} centered>
				<Modal.Header closeButton>
					<Modal.Title>{id ? 'Edit property attribute' : 'Add attribute to property'}</Modal.Title>
				</Modal.Header>
				<Formik validationSchema={this.validation} onSubmit={this.handleSubmit.bind(this)} initialValues={{key:key, value:value, attribute_id:id}}>	
					{({ handleSubmit, handleChange, values, touched, errors }) => (
						<Form noValidate onSubmit={handleSubmit}>
							{this.state.status.sent === null ? (
								<React.Fragment>
									<Modal.Body>
										<input type="hidden" name="attribute_id" value={id} />
										<Row className="mb-3">
											<Form.Group as={Col} md="6" controlId="validationFormik01">
												<Form.Label>Label</Form.Label>
												<Form.Control type="text" name="key" placeholder="" value={values.key } onChange={handleChange} isValid={touched.key && !errors.key && !errors.key && !errors.uniqueKey} isInvalid={errors.key || errors.uniqueKey}/>
												<Form.Control.Feedback type="invalid" className={errors.uniqueKey && 'd-none'}>
													Please provide a valid key.
												</Form.Control.Feedback>
											</Form.Group>
											<Form.Group as={Col} md="6" controlId="validationFormik00">
												<Form.Label>Value</Form.Label>
												<Form.Control type="text" name="value" placeholder="" value={values.value } onChange={handleChange} isValid={touched.value && !errors.value} isInvalid={errors.value}/>
												<Form.Control.Feedback type="invalid" className={errors.uniqueKey && 'd-none'}>
													Please provide a valid value.
												</Form.Control.Feedback>
											</Form.Group>
										</Row>
										
										{touched.key && errors.uniqueKey &&
										<Row>
											<div className="text-danger">
												<i className="ri-error-warning-line"></i> {errors.uniqueKey}
											</div>
										</Row>
										}
									</Modal.Body>
									
									<Modal.Footer className="mt-3">
										<Button variant="primary" type="submit">{id ? 'Save' : 'Add'} attribute</Button>
									</Modal.Footer>
								</React.Fragment>
							) : (
							<Modal.Body>
								<Row className="mb-3 dialog-feedback">
									<Col xs="12" className="dialog-feedback-icon text-center">
										{
										this.state.status.sent ?
											(this.state.status.success ? 
												(<i className="ri-checkbox-circle-line text-success"></i>)
												:
												(<i className="ri-error-warning-line text-warning"></i>)
											)
											:
											(<Spinner animation="border" variant="info" className="mt-5" />)
										}
									</Col>
									<Col xs="12" className="dialog-feedback-text mb-5">
										{this.state.status.message}
									</Col>
								</Row>
							</Modal.Body>	
							)}
						</Form>
					)}	
				</Formik>
			</Modal>
		);
	}
}

export default DialogPropertyAttribute;